import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import FaireAdsVisionPage from "../../workspace/tm/faire-ads-vision";
import ScenarioPlanningToolPage from "../../workspace/tm/scenario-planning-tool";

const PromotedListingsSettingsPage2027V2 = lazy(
  () => import("../../pages/faire/PromotedListingsSettingsPage2027V2")
);
const AdsHomeWidgetPage = lazy(
  () => import("../../pages/faire/AdsHomeWidgetPage")
);
const PromotedListingsBudgetFlexPage = lazy(
  () => import("../../pages/faire/PromotedListingsBudgetFlexPage")
);
const AdsRetailerCategoryPage = lazy(
  () => import("../../pages/faire/AdsRetailerCategoryPage")
);

export function TanyaMaRoutes() {
  return (
    <Switch>
      <Route path="/tm/faire-ads-vision" component={FaireAdsVisionPage} />
      <Route
        path="/tm/faire/promoted-listings-2027"
        component={PromotedListingsSettingsPage2027V2}
      />
      <Route path="/tm/faire/ads-home-widget" component={AdsHomeWidgetPage} />
      <Route
        path="/tm/faire/promoted-listings-budget-flex"
        component={PromotedListingsBudgetFlexPage}
      />
      <Route
        path="/tm/faire/ads-retailer-category-controls"
        component={AdsRetailerCategoryPage}
      />
      <Route
        path="/tm/scenario-planning-tool"
        component={ScenarioPlanningToolPage}
      />
    </Switch>
  );
}

export const slug = "tm";
